import { render, staticRenderFns } from "./JoininStep.vue?vue&type=template&id=10085712&scoped=true&"
import script from "./JoininStep.vue?vue&type=script&lang=js&"
export * from "./JoininStep.vue?vue&type=script&lang=js&"
import style0 from "./JoininStep.vue?vue&type=style&index=0&id=10085712&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10085712",
  null
  
)

export default component.exports